import { useParams } from "react-router-dom";
import { useHeaderContext } from "../../../context/headerContext";
import { useEffect, useState } from "react";
import GuestBandStep1 from "./step1";
import GuestBandStep2 from "./step2";
import GuestBandStep3 from "./step3";
import GuestBandStep4 from "./step4";
import { useLocation } from "react-router-dom";

export default function ActivateGuestBand() {
  const { step } = useParams();
  const { state } = useLocation();
  const { band } = state;
  const { setTitle, setBackButton } = useHeaderContext();

  useEffect(() => {
    setTitle("Activate Band");
    setBackButton(true);
  }, []);

  // LogErrors(user, logout, updateTokens, JSON.stringify(band));
//   {
//     "BandID":"3969d87d-c98a-4947-9497-ff3caefecac8",
//     "OrgId":"2",
//     "BandColour":"BLACK",
//     "ParticipantId":"3ef52a95-09d8-4473-9147-f3a85462e278",
//     "ParticipantName":"Jane Miller",
//     "Nickname":"Jane's Band",
//     "ProfilePicture":"https://stsportsguardianprod001.blob.core.windows.net/profilepictures/Screenshot-2024-10-01-at-14.57.43.png",
//     "CurrentZone":"",
//     "BandState":-1,
//     "BandStateVerbose":"NOT ACTIVATED",
//     "SessionId":"",
//     "TransferPending":0,
//     "BandImageURL":"https://stsportsguardianprod001.blob.core.windows.net/pwabandcards/2_BLACK.png",
//     "LastUpdated":"2024-09-25 12:27:00"
//     "IsGuestBand"
//   }
  
  let content;
  if (step >= 1 && step <= 4) {
    // Render specific screens based on step value
    switch (step) {
      case "1":
        content = <GuestBandStep1 band={band} />;
        break;
      case "2":
        content = <GuestBandStep2 band={band} />;
        break;
      case "3":
        content = <GuestBandStep3 band={band} />;
        break;
      case "4":
        content = <GuestBandStep4 band={band} />;
        break;
      default:
        content = <GuestBandStep1 band={band} />;
        break;
    }
  } else {
    // Render 404 page for invalid step value
    throw Error;
  }

  return <>{content}</>;
}
